export default "__VITE_ASSET__BF4vW9V8__"